import React from "react";
import mixpanel from "mixpanel-browser";
import { useSelector } from "react-redux";
import { Collapse, ListItemText } from "@mui/material";
import { isEmpty } from "lodash";
import { RootState } from "../../../redux/store";
import { NavigationChildrenProps, NavItem } from "../types";
import {
  NestedListItem,
  NestedListItemContainer,
  StyledRadioButton,
} from "./styled";
import { fontSizes } from "../../../layouts/fontSizes";

const NavigationChildren = ({
  childrenItems,
  isOpen,
  selectedPage,
  setSelectedPage,
}: NavigationChildrenProps) => {
  const { user } = useSelector((state: RootState) => state.profile);

  const handleChildClick = (child: NavItem) => {
    const ChildValue = String(child.value);
    setSelectedPage(ChildValue);

    if (!isEmpty(child?.mixpanelEvent)) {
      mixpanel.track(`${child.mixpanelEvent}`, {
        session_type: "admin_app",
        origin: "navigation",
        "Side nav menu item clicked": new Date().toISOString(),
        user_email: user?.email,
      });
    }
  };
  return (
    <Collapse in={isOpen} timeout="auto" unmountOnExit>
      <NestedListItemContainer disablePadding>
        {childrenItems?.map((child, index) => {
          const ChildValue = String(child.value);
          const isChildSelected = selectedPage === ChildValue;
          return (
            <NestedListItem
              key={index}
              onClick={() => handleChildClick(child)}
              selected={isChildSelected}
            >
              <StyledRadioButton
                checked={isChildSelected}
                value={ChildValue}
                onChange={() => setSelectedPage(ChildValue)}
                inputProps={{ "aria-label": child.title }}
                size="small"
              />
              <ListItemText
                primary={child.title}
                primaryTypographyProps={{
                  fontSize: fontSizes.default,
                  marginLeft: "5px",
                }}
              />
            </NestedListItem>
          );
        })}
      </NestedListItemContainer>
    </Collapse>
  );
};

export default NavigationChildren;
